export const getObjectProperty = (obj: unknown, path: string): unknown => {
  if (!obj || !path) return null
  const keys = path?.split('.')
  let result = obj

  for (const key of keys) {
    if (result !== null && typeof result === 'object' && key in result) {
      result = result[key]
    } else {
      return null
    }
  }

  return result
}
